/**
 * SwitchSettings.tsx
 * Switchカードの設定ダイアログの中身（比較値）
 */
import { useReactFlow } from '@xyflow/react';
import type { NodeSettingsProps } from '../../types';
import { useFlowDisplayLanguage } from '../../displayLanguage';

export function SwitchSettings({ node }: NodeSettingsProps<'switch'>) {
  const { updateNodeData } = useReactFlow();
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <div className="space-y-4">
      <label className="block" data-product-tour="card-input-1">
        <span className="mb-1 block text-sm font-medium text-slate-700">
          {displayLanguage === 'en' ? 'word 1' : 'ことば1'}
        </span>
        <input
          type="text"
          value={node.data.matchValue1 ?? ''}
          onChange={(event) => updateNodeData(node.id, { matchValue1: event.target.value })}
          className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-indigo-400"
        />
      </label>
      <label className="block" data-product-tour="card-input-2">
        <span className="mb-1 block text-sm font-medium text-slate-700">
          {displayLanguage === 'en' ? 'word 2' : 'ことば2'}
        </span>
        <input
          type="text"
          value={node.data.matchValue2 ?? ''}
          onChange={(event) => updateNodeData(node.id, { matchValue2: event.target.value })}
          className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-indigo-400"
        />
      </label>
    </div>
  );
}
